import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useAppActions, useAppSelector} from '../../../../../hooks/runtime'
import {getPreliminaryInvoice} from '../../../../../selectors/placed-order'
import {isInAccessibilityMode} from '../../../../../selectors/seating/mode'
import {getPlacesInBasketCount} from '../../../../../selectors/seating/places'
import {InnerSummary} from '../../inner-summary'
import {StyledButton} from '../../styled-button'
import {SummaryContainer} from '../../summary-container'
import {FooterProps} from './interfaces'

export const Footer = ({onButtonClick}: FooterProps) => {
  const {t} = useTranslation()
  const {setShowAccessibilityMode} = useAppActions()

  const placesInBasketCount = useAppSelector(getPlacesInBasketCount)
  const invoice = useAppSelector(getPreliminaryInvoice)
  const showAccessibilityMode = useAppSelector(isInAccessibilityMode)

  const handleButtonClick = () => (onButtonClick ? onButtonClick() : setShowAccessibilityMode(false))

  return (
    <SummaryContainer inAccessibilityMode={showAccessibilityMode}>
      <InnerSummary invoice={invoice} selectedTicketsQuantity={placesInBasketCount} withoutBreakdown />
      <StyledButton onClick={handleButtonClick} dataHook={DH.VIEW_BASKET}>
        {t('seatings_viewBasket')}
      </StyledButton>
    </SummaryContainer>
  )
}
